
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useMasterLicense } from '@/hooks/useMasterLicense';
import MasterLicenseLayout from '@/components/masterlicense/MasterLicenseLayout';
import ResellerCRM from '@/components/masterlicense/crm/ResellerCRM';

const MasterLicenseResellerCRM = () => {
  const navigate = useNavigate();
  const {
    isLoading,
    handleLogout,
  } = useMasterLicense();

  return (
    <MasterLicenseLayout
      isLoading={isLoading}
      onLogout={handleLogout}
      activeTab="reseller-crm"
      userRole="Master Admin"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold">Reseller Customer Management</h1>
          <p className="text-gray-600">
            Manage your Reseller Pro customers' information and communications
          </p>
        </div>
        
        <ResellerCRM />
      </div>
    </MasterLicenseLayout>
  );
};

export default MasterLicenseResellerCRM;
